import moment from 'moment';
import { TFunction } from 'i18next';
import { ApiError, OrgRole, OrgUserOut, UserCredentialsOut } from '../api';

export const ASSIGNABLE_ROLES = [OrgRole.EMPLOYEE, OrgRole.SUPERVISOR, OrgRole.ADMIN];

export const apiErrorDetail = (error: unknown): string | undefined =>
  error instanceof ApiError ? error.body?.detail : undefined;

export const userFullName = (user: OrgUserOut): string => `${user.first_name} ${user.last_name}`.trim();

export const userInitials = (user: OrgUserOut): string =>
  `${user.first_name.charAt(0)}${user.last_name.charAt(0)}`.toUpperCase();

export const formatLastActive = (lastActiveAt: string): string => {
  const lastActive = moment(lastActiveAt);
  return lastActive.isSame(moment(), 'day') ? lastActive.format('HH:mm') : lastActive.format('D MMMM');
};

type CredentialsMessageParams = {
  user: OrgUserOut;
  credentials: UserCredentialsOut;
  studio: string;
  isNewUser: boolean;
};

export const buildCredentialsMessage = (
  t: TFunction,
  { user, credentials, studio, isNewUser }: CredentialsMessageParams,
) =>
  t(isNewUser ? 'users.credentials.message_new_user' : 'users.credentials.message_reset', {
    firstName: user.first_name,
    studio,
    adminUrl: credentials.admin_url,
    email: credentials.email,
    password: credentials.password,
  });

export const formatBlockedBy = (t: TFunction, user: OrgUserOut): string | undefined =>
  user.blocked_at
    ? t('users.drawer.blocked_by', {
        name: user.blocked_by_name ?? t('users.monkeybook_support'),
        date: moment(user.blocked_at).format('D MMMM YYYY, HH:mm'),
      })
    : undefined;

const MONKEYBOOK_STAFF_EMAIL_PREFIX = 'info+';

export const isReservedEmail = (email?: string): boolean =>
  !!email && email.trim().toLowerCase().startsWith(MONKEYBOOK_STAFF_EMAIL_PREFIX);
